<mat-card>
    <div>
        <mat-form-field appearance="outline" class="csp1">
            <mat-label>Select Scheme Name</mat-label>
            <mat-select placeholder="Select Scheme Name" name=Rightsupdate>
                <mat-option *ngFor="let ob of navtableDetails" [value]="ob.SCHEME_NAME" (click)="navtablevalue(ob.SCHEME_CODE)">
                    {{ob.SCHEME_NAME}}</mat-option>
            </mat-select>
            <!-- <mat-hint class="error-clr" *ngIf="Rightsupdate">User Rights is required</mat-hint> -->
        </mat-form-field>
    </div>
    <div class="csp2">
        <table mat-table [dataSource]="navtableReport" class="mat-elevation-z8">

            <ng-container matColumnDef="NAV_DATE">
                <th mat-header-cell *matHeaderCellDef class="csp3"> NAV DATE </th>
                <td mat-cell *matCellDef="let element"> {{formatDate(element.NAV_DATE)}} </td>
            </ng-container>

            <ng-container matColumnDef="NAV">
                <th mat-header-cell *matHeaderCellDef class="csp3"> NAV </th>
                <td mat-cell *matCellDef="let element" > {{element.NAV}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</mat-card>